window.Flickity = require("flickity");
import "flickity-imagesloaded";
window.asNavFor = require("flickity-as-nav-for");

const options = {
    imagesLoaded: true,
    // watchCSS: true,
    cellAlign: "center",
    groupCells: 1,
    autoPlay: false,
    arrowShape: {
        x0: 10,
        x1: 70,
        y1: 40,
        x2: 70,
        y2: 40,
        x3: 70
    }
};


const desktopDetailOpts = Object.assign({}, options, {
    groupCells: true,
    pageDots: false,
    wrapAround: false,
    prevNextButtons: true,
    contain: true,
    arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 65,
        y2: 45,
        x3: 20
    }
});

const mainImageOpts = Object.assign({}, options, {
    groupCells: 1,
    pageDots: false,
    wrapAround: false,
    prevNextButtons: false
});

const carouselOpts = Object.assign({}, options, {
    groupCells: 4,
    pageDots: false,
    wrapAround: false,
    prevNextButtons: false,
    asNavFor: ".main-image-carousel",
    contain: true
});

if (document.querySelector(".carousel-related-items")) var relatedFlickity = new Flickity(".carousel-related-items", desktopDetailOpts);
if (document.querySelector(".carousel-best-sellers-items")) var bestSellersFlickity = new Flickity(".carousel-best-sellers-items", desktopDetailOpts);
if (document.querySelector(".main-image-carousel")) var mainImageFlickity = new Flickity(".main-image-carousel", mainImageOpts);
if (document.querySelector(".carousel-nav")) var carouselImageFlickity = new Flickity(".carousel-nav", carouselOpts);

const carousels = ['.carousel-related-items', '.carousel-best-sellers-items'];
for (let carousel of carousels) {
    let height = 0;
    let items = [...document.querySelectorAll(carousel + ' a')];
    for (let item of items) {
        if (item.offsetHeight > height) {
            height = item.offsetHeight;
        }
    }
    for (let item of items) {
        item.style.height = `${height}px`;
    }
}
